import ContentfulService from 'web-core/src/contentful-service';
import { RECEIVE_HEALTH_GUIDE, REMOVE_HEALTH_GUIDE } from '../constants/guide';

export const receiveHealthGuide = (healthGuide: Object) => ({
  type: RECEIVE_HEALTH_GUIDE,
  healthGuide,
});

export const removeHealthGuide = () => ({
  type: REMOVE_HEALTH_GUIDE,
});

export function fetchHealthGuide() {
  return (dispatch, getState, { apiClient }) => {
    const svc = new ContentfulService({ client: apiClient });
    return svc.getEntryById('1yGbhR1ovCu0MMqawGgYOC').then((healthGuide) => {
      dispatch(receiveHealthGuide(healthGuide));
      return healthGuide;
    });
  };
}
